<template>
  <div class="deviceShadow">
    <div class="topTitle">
      <img :src="require('../../../../assets/device_icon_title_yellow.svg')" class="titleSvg" />
      <span class="titleMid">{{ $t('Device.cookingRecipe') }}:</span>
      <span class="titleRecipeName">{{ row.menuName | format }}</span>
    </div>
    <div class="centerIcon" v-if="row.currStepType === 1">
      <img :src="require('../../../../assets/device_pic_preheat.svg')" class="cookingIcon" />
    </div>
    <div class="centerIcon" v-else>
      <img :src="require('../../../../assets/device_pic_cooking.svg')" class="cookingIcon" />
    </div>
    <div class="statusName" v-if="row.currStepNum <= row.totalStepNum">
      {{ row.currStepType === 1 ? $t(`Device.preHeating`) : $t(`Device.cooking`) }}
    </div>

    <div class="stepListDiv">
      <div
        :class="row.currStepNum > i ? 'stepItemFinish' : 'stepItem'"
        v-for="(step, i) in row.totalStepNum"
        :key="i"
      ></div>
    </div>
    <div class="currentStepName" v-if="row.currStepNum <= row.totalStepNum">
      {{ DeviceCurrStepType[row.currStepType] }}
    </div>
    <div class="currentStepProcess">
      {{
        row.currStepNum > row.totalStepNum
          ? $t(`Device.cookCompleted`)
          : `(${row.currStepNum | format}/${row.totalStepNum | format})`
      }}
    </div>
  </div>
</template>

<script>
import { format, formatTime, formatNumWithComma } from '@/utils/utils'
import { DeviceCurrStepType } from '@/config/status'
export default {
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  filters: {
    format,
    formatTime,
    formatNumWithComma
  },
  data() {
    return {
      DeviceCurrStepType
    }
  }
}
</script>

<style scoped lang="scss">
.deviceShadow {
  width: 332px;
  height: 208px;
  border-radius: 16px;
  border: 1px solid #dcdfe6;
  padding: 16px;
  .topTitle {
    display: flex;
    align-items: center;
    .titleSvg {
      height: 14px;
      width: 14px;
      margin-right: 8px;
      line-height: 22px;
    }
    .titleMid {
      margin-right: 8px;
      font-size: 12px;
      height: 14px;
      font-weight: 400;
      color: #333333;
    }
    .titleRecipeName {
      font-size: 14px;
      font-weight: 600;
      color: #333333;
    }
  }
  .centerIcon {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 8px auto auto auto;
    .cookingIcon {
      width: 72px;
      height: 72px;
    }
  }
  .statusName {
    text-align: center;
    color: #ffa70b;
    line-height: 22px;
  }
  .stepListDiv {
    display: flex;
    margin-top: 14px;
    .stepItem {
      margin-left: 4px;
      flex: 1;
      width: 100%;
      height: 4px;
      background: #e6e8eb;
      &:first-child {
        margin-left: 0;
      }
    }
    .stepItemFinish {
      margin-left: 4px;
      flex: 1;
      width: 100%;
      height: 4px;
      background: #ffa70b;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  .currentStepName {
    text-align: center;
    font-weight: 600;
    color: #333333;
    // line-height: 22px;
    margin: 8px auto 0 auto;
  }
  .currentStepProcess {
    margin-top: 8px;
    text-align: center;
    font-weight: 400;
    color: #333333;
    //line-height: 20px;
    font-size: 12px;
  }
}
</style>
